import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowLeft01Icon } from '@hugeicons/core-free-icons';
import { Button } from '@/components/ui/button';
import { SelectionCard } from './SelectionCard';
import { log } from '@/lib/logger';

interface StepGoalProps {
  goal: string;
  onSelect: (goal: string) => void;
  onBack: () => void;
  /** True while the invited-mode finish is posting; disables the cards. */
  isSubmitting?: boolean;
}

const GOALS = [
  'Catching design inconsistencies',
  'Streamlining feedback loops',
  'Replacing screenshot-based bug reports',
  'Collaborating with my team',
];

export function StepGoal({ goal, onSelect, onBack, isSubmitting = false }: StepGoalProps) {
  log.info('[StepGoal] render', { goal, isSubmitting });

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="hero-title">What do you want to accomplish?</h2>
      </div>

      <div className="space-y-3">
        {GOALS.map((g) => (
          <SelectionCard
            key={g}
            label={g}
            selected={goal === g}
            disabled={isSubmitting}
            onClick={() => {
              log.info('[StepGoal] goal selected', { g });
              onSelect(g);
            }}
          />
        ))}
      </div>

      {/* Pending indicator while the invited finish posts. Mirrors the
          StepProject submit spinner shape (visible border color on the
          white card instead of border-white on a filled button). */}
      {isSubmitting && (
        <div role="status" className="flex items-center justify-center gap-2 text-sm text-gray-500">
          <span className="h-4 w-4 animate-spin rounded-full border-2 border-primary-500 border-t-transparent" />
          Finishing up...
        </div>
      )}

      <div className="pt-2">
        <Button
          variant="ghost"
          size="md"
          disabled={isSubmitting}
          onClick={() => {
            log.info('[StepGoal] back clicked');
            onBack();
          }}
        >
          <span className="flex items-center gap-2">
            <HugeiconsIcon icon={ArrowLeft01Icon} size={16} strokeWidth={2} color="currentColor" className="h-4 w-4" />
            Back
          </span>
        </Button>
      </div>
    </div>
  );
}
